export default __webpack_public_path__ + "static/media/comment.4cca09fe.jpg";